import React, { FC } from 'react';

import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import { FranchisePages } from '../../../redux/ducks/franchises/viewTypes';

import FranchiseDisplay from './FranchiseDisplay';

import './styles.scss';

type Props = {
    team: any;
    season?: number | undefined;
    useInTable?: boolean;
    displayNameOverride?: string;
    displayLogo?: boolean;
    displayName?: boolean;
    displayTricode?: boolean;
    franchisePage?: FranchisePages | boolean;
    className?: string;
    append?: any;
    props?: any;
};

const TeamDisplayModule: FC<Props> = ({
    team,
    season,
    useInTable = false,
    displayLogo = true,
    displayName = true,
    displayNameOverride,
    displayTricode = false,
    franchisePage,
    className,
    append,
    ...props
}: Props) => {
    if (team === undefined) {
        return null;
    }

    const teamDisplay = (
        <TeamDisplay
            team={team}
            season={season}
            useInTable={useInTable}
            displayLogo={displayLogo}
            displayName={displayName}
            displayNameOverride={displayNameOverride}
            displayTricode={displayTricode}
            className={`${className}${useInTable ? ' in-table' : ''}`}
            append={append}
            {...props}
        />
    );

    return franchisePage ? (
        <FranchiseDisplay team={team} teamDisplay={teamDisplay} franchisePage={franchisePage} />
    ) : (
        teamDisplay
    );
};

export default TeamDisplayModule;
